import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ISaleAttemptReport, IResponseReportBinBlock } from 'src/app/domain/interfaces/funnel/interface-report-bin-block-response';
import { AddressType } from 'src/app/domain/models/funnel/address-type-enum';
import { PaymentProviderEnum } from 'src/app/domain/models/funnel/Payment-provider-enum';
import { FunnelFlow } from 'src/app/domain/models/funnel/register-funnels/funnel-flow-register';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportBinService {

  constructor(private http: HttpClient) { }

  private addSaleAttempt(dataReportUserBlockBin: ISaleAttemptReport): Observable<IResponseReportBinBlock> {
    return this.http.post<IResponseReportBinBlock>(`${environment.apiNodeUrl}/reports/sales-add`, { ...dataReportUserBlockBin }).pipe(map((responseBinBlock: IResponseReportBinBlock) => {
      return responseBinBlock;
    }));
  }

  public reportSaleFromFunnel(FunnelFlow: FunnelFlow, attemptTypeData: string, bin?: string) {
    let userAddress = FunnelFlow.UserTemporary?.addresses?.find(address => address.addressType == AddressType.Primary);
    let saleAttemptReport: ISaleAttemptReport = {
      name: `${FunnelFlow.UserTemporary?.firstName} ${FunnelFlow.UserTemporary?.lastName}`,
      email: FunnelFlow.UserTemporary?.email!,
      phone: FunnelFlow.UserTemporary?.phone,
      state: userAddress?.state,
      konnektiveCustomerId: FunnelFlow?.UserTemporary?.crmCustomerId,
      konnektiveOrderId: FunnelFlow.UserTemporary?.orderId,
      offerId: FunnelFlow.SubscriptionProduct?.funnel?.offerId,
      affiliateId: FunnelFlow.EverflowAffiliate?.everflowAffiliateId,
      everflowTransactionId: FunnelFlow.UserEverflowEvent?.EverflowTransactionId,
      everflowSub1: FunnelFlow.UserEverflowEvent?.EverflowSub1,
      everflowSub2: FunnelFlow.UserEverflowEvent?.EverflowSub2,
      everflowSub3: FunnelFlow.UserEverflowEvent?.EverflowSub3,
      creditCardBIN: bin || "",
      result: attemptTypeData,
      ipAddress: FunnelFlow?.SourceIPAddress?.split(",")[0],
      crmType: PaymentProviderEnum[FunnelFlow.SubscriptionProduct?.funnel?.paymentProvider!]
    }
    this.addSaleAttempt(saleAttemptReport).subscribe(() => { });
  }

}
